function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect } from 'react';
import { Loader } from '../../App';
import { formatDate } from '../../utils';
import consumer from '../../channels/consumer';
import moment from 'moment';
export default function Chat(_ref) {
  var appProps = _ref.appProps,
    chattableId = _ref.chattableId,
    chattableApiUid = _ref.chattableApiUid,
    chattableType = _ref.chattableType,
    createChatMessagePath = _ref.createChatMessagePath,
    fetchChatMessagesPath = _ref.fetchChatMessagesPath,
    chatTitle = _ref.chatTitle;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    fetching = _useState2[0],
    setFetching = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    loading = _useState4[0],
    setLoading = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    chatMessages = _useState6[0],
    setChatMessages = _useState6[1];
  var _useState7 = useState(''),
    _useState8 = _slicedToArray(_useState7, 2),
    reply = _useState8[0],
    setReply = _useState8[1];
  var _useState9 = useState(null),
    _useState10 = _slicedToArray(_useState9, 2),
    userInfo = _useState10[0],
    setUserInfo = _useState10[1];
  var translations = appProps.translations,
    flashMessage = appProps.flashMessage,
    user = appProps.user;
  var currentDate = formatDate(new Date(), true).date;
  useEffect(function () {
    fetchReplies();
    var cable = consumer.subscriptions.create({
      channel: 'ChatChannel',
      chattable_type: chattableType,
      chattable_api_uid: chattableApiUid
    }, {
      received: function received(data) {
        receivedMessage(data);
      }
    });
    return function () {
      consumer.subscriptions.remove(cable);
    };
  }, []);
  function fetchReplies() {
    setFetching(true);
    Rails.ajax({
      type: 'GET',
      url: "".concat(fetchChatMessagesPath, "?chattable_id=").concat(chattableId, "&chattable_type=").concat(chattableType),
      dataType: 'json',
      success: function success(res) {
        setChatMessages(res.items.map(function (message) {
          return _objectSpread(_objectSpread({}, message), formatDate(message.createdAt, true));
        }));
        if (res.userInfo) {
          setUserInfo(res.userInfo);
        }
      },
      complete: function complete(res) {
        setFetching(false);
      }
    });
  }
  function receivedMessage(data) {
    var action = data.action;
    var message = data.data.message;
    switch (action) {
      case 'Create':
        setTimeout(function () {
          setChatMessages(function (prevState) {
            if (!prevState.map(function (item) {
              return item.id;
            }).includes(message.id)) {
              return [].concat(_toConsumableArray(prevState), [_objectSpread(_objectSpread({}, message), formatDate(message.createdAt, true))]);
            }
            return prevState;
          });
        }, 200);
        break;
    }
  }
  function sendReply() {
    setLoading(true);
    if (reply.trim() === "") {
      return;
    }
    var formData = new FormData();
    formData.append('message[content]', reply);
    Rails.ajax({
      url: "".concat(createChatMessagePath, "?chattable_type=").concat(chattableType, "&chattable_id=").concat(chattableId),
      type: 'POST',
      dataType: 'json',
      data: formData,
      success: function success(res) {
        setChatMessages(function (prevState) {
          return [].concat(_toConsumableArray(prevState), [_objectSpread(_objectSpread({}, res.message), formatDate(res.message.createdAt, true))]);
        });
      },
      error: function error(res) {
        flashMessage.show('Error', 'error');
      },
      complete: function complete(res) {
        setLoading(false);
        setReply('');
      }
    });
  }
  function renderMessages() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, chatMessages.map(function (message, index) {
      var previousMessage = index >= 0 && chatMessages[index - 1];
      var nextMessage = index < chatMessages.length - 1 && chatMessages[index + 1];
      var messageCreator = message.user || message.chatter;
      var isCurrentUser = !!message.user;
      var avatar = message.user && userInfo && userInfo.avatar;
      var messageCreatorName = message.user ? userInfo ? userInfo.fullname : translations.general.user : messageCreator.fullname || messageCreator.fullName || messageCreator.full_name || message.chatter && translations.general.administrator;
      var messagerType = message.user ? 'user' : message.chatter.type;
      var messagerIcon = messagerType === 'user' ? 'fa-circle-user' : messagerType === 'administrator' ? 'fa-user-shield' : 'fa-user-tie';
      var showDate = !previousMessage || previousMessage.date !== message.date;
      var showUser = showDate || !previousMessage || previousMessage.user && message.chatter || previousMessage.chatter && message.user || previousMessage.user && message.user && previousMessage.user.id !== message.user.id || previousMessage.chatter && message.chatter && (previousMessage.chatter.id !== message.chatter.id || previousMessage.chatter.type !== message.chatter.type);
      var showTime = !nextMessage || nextMessage.createdAt !== message.createdAt || nextMessage.user && message.chatter || nextMessage.chatter && message.user || nextMessage.user && message.user && nextMessage.user.id !== message.user.id || nextMessage.chatter && message.chatter && (nextMessage.chatter.id !== message.chatter.id || nextMessage.chatter.type !== message.chatter.type) || moment(nextMessage.time, 'HH:mm') - moment(message.time, 'HH:mm') > 60000;
      return /*#__PURE__*/React.createElement("div", {
        key: message.id,
        className: "comment-wrapper"
      }, showDate && /*#__PURE__*/React.createElement("div", {
        className: "comment-date flex-box content-center"
      }, message.date == currentDate ? 'Today' : message.date), showUser && /*#__PURE__*/React.createElement("div", {
        className: "comment-header flex-box ".concat(isCurrentUser ? 'content-end' : '')
      }, isCurrentUser && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "comment-user reversed"
      }, messageCreatorName), avatar && /*#__PURE__*/React.createElement("img", {
        className: "comment-avatar",
        src: avatar
      }), !avatar && /*#__PURE__*/React.createElement("div", {
        className: "comment-avatar-icon-wrapper flex-box items-center content-center"
      }, /*#__PURE__*/React.createElement("i", {
        className: "comment-avatar-icon fal ".concat(messagerIcon, " color-scheme")
      }))), !isCurrentUser && /*#__PURE__*/React.createElement(React.Fragment, null, avatar && /*#__PURE__*/React.createElement("img", {
        className: "comment-avatar",
        src: avatar
      }), !avatar && /*#__PURE__*/React.createElement("div", {
        className: "comment-avatar-icon-wrapper flex-box items-center content-center"
      }, /*#__PURE__*/React.createElement("i", {
        className: "comment-avatar-icon fal ".concat(messagerIcon, " color-scheme")
      })), /*#__PURE__*/React.createElement("div", {
        className: "comment-user"
      }, messageCreatorName))), /*#__PURE__*/React.createElement("div", {
        className: "flex-box ".concat(isCurrentUser ? 'content-end' : '')
      }, /*#__PURE__*/React.createElement("div", {
        className: "comment-content-wrapper ".concat(isCurrentUser ? 'reversed' : '', " ").concat(showTime ? 'time' : '')
      }, /*#__PURE__*/React.createElement("div", {
        className: "comment-content ".concat(showTime ? 'time' : ''),
        dangerouslySetInnerHTML: {
          __html: message.content.replaceAll('\n', '<br/>') + (showTime ? "<span class='comment-info flex-box items-end'>".concat(message.time, "</span>") : '')
        }
      }))));
    }));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "card"
  }, /*#__PURE__*/React.createElement("h3", null, /*#__PURE__*/React.createElement("b", null, chatTitle)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "chat-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "chat-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "comments-wrapper"
  }, renderMessages()))), /*#__PURE__*/React.createElement("div", {
    className: "chat-wrapper"
  }, fetching && /*#__PURE__*/React.createElement(Loader, {
    size: "medium",
    position: "center"
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex-box items-end"
  }, !fetching && !loading && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("textarea", {
    className: "new-comment",
    style: {
      marginTop: '10px',
      marginRight: 20
    },
    value: reply,
    onChange: function onChange(event) {
      return setReply(event.target.value);
    }
  }), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn flex-box",
    disabled: loading || !reply,
    onClick: function onClick() {
      return sendReply();
    }
  }, translations.general.submit))))));
}